
import { Vue } from 'vue-class-component'

export default class App extends Vue {
  render () {
    return (
      <div>
        <div class="loader">loading</div>
      </div>
    )
  }
}
